import { action, runInAction, computed } from "mobx";
import rootService from "../@data/service";
import required from "@libs/required";

const { getReviews, countReviews } = rootService;

class Reviews {
	constructor(rootStore) {
		this.rootStore = rootStore;
	}

	@action
	async init({ limit, skip, providerId }) {
		const data = await this.get({
			filter: {
				...this.filter,
				provider: providerId,
			},
			skip,
			limit,
			sort: this.sort,
		});

		const count = await this.getCount({
			filter: {
				...this.filter,
				provider: providerId,
			},
		});

		runInAction(() => {
			this._items = this.parseReviews(data);
			this._count = count;
			this._page = 1;
		});
	}

	async get({ filter = required`filter`, sort, limit, skip }) {
		try {
			const reviews = await getReviews({ filter, limit, skip, sort });
			return reviews;
		} catch (err) {
			throw new Error(err);
		}
	}

	async getCount({ filter = required`filter` }) {
		try {
			const count = await countReviews({ filter });
			return count;
		} catch (err) {
			throw new Error(err);
		}
	}

	@action
	async loadMore(providerId) {
		if (!this.hasMore) return;

		const [reviews, count] = await Promise.all([
			this.get({
				filter: {
					...this.filter,
					provider: providerId,
				},
				limit: 10,
				skip: this._items.length,
				sort: this.sort,
			}),
			this.getCount({
				filter: {
					...this.filter,
					provider: providerId,
				},
			}),
		]);
		this._items.push(...this.parseReviews(reviews));
		this._count = count;
		++this._page;
	}

	@computed
	get hasMore() {
		return this._page < Math.ceil(this._count / 10);
	}

	parseReviews(reviews) {
		return reviews.map((review) => ({
			...review,
			media:
				!!review.media &&
				review.media.map((el) => ({
					key: el.key,
					media_type: el.media_type,
					approved: el.approved,
					...(el.media_type === "video" ? el.video : el.picture),
				})),
		}));
	}
}

export default Reviews;
